/**
 * @generated SignedSource<<f3d97f5b5e05de59dbc5775934b0a3ee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type OAuthLinkInstagramLoginEnabledQuery$variables = {};
export type OAuthLinkInstagramLoginEnabledQuery$data = {
  readonly instagramLoginEnabled: boolean;
};
export type OAuthLinkInstagramLoginEnabledQuery = {
  response: OAuthLinkInstagramLoginEnabledQuery$data;
  variables: OAuthLinkInstagramLoginEnabledQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "instagramLoginEnabled",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "OAuthLinkInstagramLoginEnabledQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "OAuthLinkInstagramLoginEnabledQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "842fb363e5301526f2b3bfe2a56ba290",
    "id": null,
    "metadata": {},
    "name": "OAuthLinkInstagramLoginEnabledQuery",
    "operationKind": "query",
    "text": "query OAuthLinkInstagramLoginEnabledQuery {\n  instagramLoginEnabled\n}\n"
  }
};
})();

(node as any).hash = "90817539f06a8bc53a08e31346a3a4a6";

export default node;
